import { Link } from 'react-router-dom'
import "./Footer.css"
import InfoLegali from "./InfoLegali"
import logo from "../img/loghi/logo-trasparente.png"

const Footer = () => {
    return (
        <div id="footer">

            {/* RIGA 1: logo principale | info legali */}
            <div className="row">
                <div className="col">
                    <Link to="/"><img src={logo} id="logo-sporting" alt="logo"/></Link>
                    <span id='version'>v26.9.6</span>
                </div>

                <div className="col">
                    <h3>Info legali:</h3>
                    <InfoLegali />
                </div>
            </div>

            {/* RIGA 2: contatti | dove siamo */}
            <div className="row">
                <div className="col item">
                    <h3>Contatti</h3>
                    <div>
                        <span>Tel: 333 436 3911</span>
                        <span>Email: marcotorello1979@libero.it</span>
                    </div>
                </div>

                <div className="col item">
                    <h3>Dove ci trovi</h3>
                    <div>
                        <span>Via S. Bernardino, 28</span>
                        <span>Saluzzo</span>
                    </div>
                </div>
            </div>

            
            {/* RIGA 3: logo su-di-noi | privacy policy */}
            <div className="row">
                <div className="col">
                    <Link to="/su-di-noi" className="logo-su-di-noi-link">
                        Su di noi
                    </Link>
                </div>

                <div className="col">
                    <Link to="/privacy" style={{textDecoration:"underline"}}>Privacy Policy</Link>
                </div>
            </div>

        </div>
    )
}

export default Footer